import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function StudioISection() {
  return (
    <section id="studio-i-section" className="relative bg-[#08080a] text-white py-20 lg:py-28 border-t border-white/5 overflow-hidden">
      {/* Ambient pink glow */}
      <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#d42b92]/10 blur-[170px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Column: Narrative & Content */}
          <div className="lg:col-span-6 reveal-up">
            {/* Eyebrow */}
            {/* <div className="text-[#ff8ec5] text-xs font-semibold tracking-[0.3em] uppercase mb-4 flex items-center gap-2">
              <span>STUDIO I</span>
            </div> */}

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] font-bold tracking-tight text-white leading-[1.08]">
              A runway to <span className="text-[#d42b92]">Venture Beyond.</span>
            </h2>

            {/* Body Paragraphs */}
            <div className="mt-8 space-y-5 text-white/80 text-base sm:text-lg leading-relaxed font-normal">
              <p>
                Studio I is the physical expression of the InnovHer ecosystem, a space where founders, investors, businesses, creators and ideas can come into meaningful proximity.
              </p>
              <p>
                Designed not simply as an office or coworking destination, Studio I is a working environment for venture building: conversations become collaborations, ideas find expertise, businesses meet opportunities and relationships develop beyond scheduled programs.
              </p>
            </div>

            {/* Callout Quote Box */}
            <div className="mt-8 rounded-2xl border border-white/10 bg-gradient-to-r from-[#d42b92]/15 via-white/[0.02] to-transparent p-6 sm:p-7 shadow-lg">
              <p className="italic text-white/90 text-base sm:text-lg">
                A place to arrive with an idea, build with others and leave with momentum.
              </p>
              <p className="mt-2 text-white font-bold text-lg sm:text-xl">
                Studio I is the runway to <span className="text-[#ff8ec5]">Venture Beyond.</span>
              </p>
            </div>

            {/* Explore Link */}
            <div className="mt-8">
              <Link
                to="/studio-i"
                className="inline-flex items-center gap-2 text-sm font-semibold text-[#ff8ec5] hover:text-white transition-colors group"
              >
                <span>Explore Studio I Workspace &amp; Commons</span>
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>

          {/* Right Column: Visual Photo Composition */}
          <div className="lg:col-span-6 reveal-up">
            <div className="relative pb-14 sm:pb-16 pr-3 sm:pr-6">
              {/* Primary Background Glow */}
              <div className="absolute -inset-4 rounded-3xl bg-[#d42b92]/10 blur-2xl pointer-events-none -z-10" />

              {/* Primary Photo (Top-Left: Ribbon Cutting) */}
              <div className="relative w-full rounded-2xl sm:rounded-3xl overflow-hidden border border-white/15 bg-white/[0.02] shadow-2xl aspect-[4/3] group">
                <img
                  src="/new_images/IMG_0251.webp"
                  alt="Studio I Jaipur Inauguration"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
              </div>

              {/* Secondary Overlapping Photo (Bottom-Right: Dignitary Signing) */}
              <div className="absolute -bottom-4 sm:-bottom-6 right-0 w-[62%] sm:w-[58%] rounded-xl sm:rounded-2xl overflow-hidden border-2 border-white/20 bg-black shadow-[0_20px_50px_rgba(0,0,0,0.9)] aspect-[4/3] group z-10">
                <img
                  src="/new_images/Copy of IMGL4150.webp"
                  alt="Studio I Collaboration & Signing"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent pointer-events-none" />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10 pointer-events-none" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
